<template>
  <div class="goodList">
    <el-row :gutter="20" v-show="goodList.length">
      <el-col style="width: 20%" v-for="item in goodList" :key="item.spuId">
        <div class="good-item cursor-pointer" @click="goDetail(item)">
          <div
            style="position: absolute; left: 10px; top: 20px; z-index: 1"
            v-if="item.tagNameList && item.tagNameList.length"
          >
            <el-tag
              v-for="(itm, index) in item.tagNameList"
              :key="index"
              size="mini"
              style="margin-right: 3px"
              type="danger"
              effect="dark"
            >
              {{ itm }}
            </el-tag>
          </div>
          <el-image
            v-show="item.fileUrl"
            :src="item.fileUrl"
            class="goodsImg"
            fit="contain"
          >
            <template slot="error">
              <img src="~@/assets/img/bitmap.png" class="goodsImg" />
            </template>
          </el-image>
          <img
            src="~@/assets/img/bitmap.png"
            v-show="!item.fileUrl"
            alt=""
            width="208px"
            height="208px"
          />
          <div
            class="price price_text"
            v-show="
              (item.commodityType && item.commodityType.indexOf('非标') > -1) ||
              item.isSellingPriceExpire
            "
          >
            {{ $t("home.rfq") }}
          </div>
          <good-price
            v-show="
              item.commodityType &&
              item.commodityType.indexOf('非标') === -1 &&
              !item.isSellingPriceExpire
            "
            :price="Number(item.minPrice) || 0"
          ></good-price>
          <div class="multi_line_overflow good-spu-name line-break">
            {{ item.name }}
          </div>
          <div class="spu-code">
            {{ $t("product.supplyCommodityCode") }}：{{
              item.supplyCommodityCode
            }}
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      :current-page="page"
      :page-size="limit"
      :total="total"
      v-show="total"
      layout="total, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="getDataList"
    >
    </el-pagination>
  </div>
</template>
<script>
import GoodPrice from '@/components/good-price'
import { openOther } from '@/utils'
export default {
  data () {
    return {}
  },
  props: {
    goodList: {
      type: Array,
      default: () => {
        return []
      }
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 20
    }
  },
  components: {
    GoodPrice
  },
  methods: {
    pageSizeChangeHandle (val) {},
    // 跳转页
    getDataList (val) {
      this.$emit('refushDataList', val)
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`goodDetail?spuId=${goods.spuId}&skuId=`)
    }
  }
}
</script>
<style lang='scss' scoped>
.goodList {
  background: #F9FAFB;
  .good-item {
    position: relative;
    margin-top: 3px;
    background: #fff;
    height: 350px;
    padding: 20px 10px;
    margin-bottom: 10px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
    -moz-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
    box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;

    &:hover {
      -webkit-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      -moz-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
    }
    .price_text {
      font-size: 20px;
    }
    /deep/ .price {
      margin-top: 10px;
      color: #e64c3a;
      font-weight: bold;
      .price-int {
        font-size: 20px;
      }
      .price-point {
        font-size: 10px;
      }
    }
    .good-spu-name {
      height: 34px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    .spu-code {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
    img {
      object-fit: contain;
    }
    .goodsImg {
      width: 208px;
      height: 208px;
      object-fit: contain;
    }
  }
}
</style>
